import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


import { Role } from '@app/common/interfaces';


@Injectable({
  providedIn: 'root',
})
export class RoleData {

  constructor(private _fsApi: FsApi) { }

  public create(data: Role = { id: null }) {
    return data;
  }

  public get(id, data = {}): Observable<any> {
    return this._fsApi.get(`roles/${id}`, data, { key: 'role' });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._fsApi.request('GET', 'roles', data, { key: 'roles', ...config });
  }

  public put(data, config: RequestConfig = {}): Observable<any> {
    return this._fsApi.put(`roles/${data.id}`, data, { key: 'role', ...config });
  }

  public post(data): Observable<any> {
    return this._fsApi.post('roles', data, { key: 'role' });
  }

  public delete(data): Observable<any> {
    return this._fsApi.delete(`roles/${data.id}`, data, { key: 'role' });
  }

  public save(data): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }

}
